import React, { Component } from "react";
import { connect } from "react-redux";
import { Form } from "react-bootstrap";
import { Bubble, LoaderButton, ContinueLabel } from "ctia-ui";
import FormElement from "components/FormElement";
import { submitWizardStep } from "actions/wizard";
import { handleInputChange } from "actions/request";

class RebrandInfo extends Component {
  validate() {
    const { rebrandFccId, rebrandName } = this.props.request;
    return rebrandFccId && rebrandName;
  }

  render() {
    const {
      wizard,
      model,
      request,
      submitWizardStep,
      handleInputChange
    } = this.props;

    // if (wizard.step !== 1 || !requests) return null;

    const { rebrandName, isLoading, rebrandFccId } = request;
    // console.log(model)

    return (
      <div>
        <Bubble show={true}>
          Please provide a new name for rebranded device as well as its FCC ID.
        </Bubble>
        <Form horizontal>
          <FormElement
            id="modelName"
            label="Model Name Before Rebranding"
            value={model.info.modelnumber}
          />
          <FormElement
            type="text"
            id="rebrandName"
            label="Model Name After Rebranding"
            value={rebrandName}
            onChange={handleInputChange}
          />
          <FormElement
            type="text"
            id="rebrandFccId"
            label="New FCC ID"
            value={rebrandFccId}
            onChange={handleInputChange}
          />
          <div className="text-right">
            <LoaderButton
              disabled={!this.validate()}
              bsStyle="info"
              text={<ContinueLabel />}
              show={true}
              isLoading={isLoading}
              onClick={() => submitWizardStep(wizard)}
            />
          </div>
        </Form>
      </div>
    );
  }
}

function mapStateToProps({ request, wizard, requests, model, user }) {
  return { request, wizard, requests, model, user };
}

export default connect(mapStateToProps, {
  submitWizardStep,
  handleInputChange
})(RebrandInfo);



// WEBPACK FOOTER //
// ./src/containers/request/Rebrand/RebrandInfo.js